import React, {useRef, useEffect} from "react";

const ToolbarCustomSelect = ({
                                 title,
                                 value,
                                 options,
                                 active,
                                 toggleList,
                                 handleClick,
                                 onClose,
                                 disabled = false,
                                 loadFonts = false
                             }) => {
    const selectId = `custom-select-${title.replace(/\s+/g, '-').toLowerCase()}`;
    const wrapperRef = useRef(null);

    useEffect(() => {
        if (!active) return;

        const handleMouseDown = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                onClose?.();
            }
        };
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose?.();
            }
        };

        document.addEventListener('mousedown', handleMouseDown);
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('mousedown', handleMouseDown);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [active, onClose]);

    return (
        <div className="custom-select" role="group" aria-label={title} ref={wrapperRef}>
            <label className="custom-select__label" id={`${selectId}-label`} htmlFor={selectId}>{title}</label>
            <div className="custom-select__select-wrapper">
                {
                    !value ?
                        <span className="custom-select__placeholder">---</span> :
                        <select
                            id={selectId}
                            onClick={toggleList}
                            title={title}
                            className="custom-select__select"
                            disabled={disabled}
                            aria-label={title}
                            aria-labelledby={`${selectId}-label`}
                            aria-disabled={disabled}
                        >
                            {
                                !value ?
                                    <option value="0" selected aria-selected="true">---</option> :
                                    <option value={value} selected="selected" aria-selected="true">{value}</option>

                            }
                        </select>
                }
            </div>
            <div>
                <ul
                    className={`custom-select__list ${active ? 'active' : ''}`}
                    role="listbox"
                    aria-label={`Opcje dla ${title}`}
                    tabIndex={active ? 0 : -1}
                >
                    {options.map((option) => (
                        <li
                            key={option.value}
                            id={`${selectId}-option-${option.value}`}
                            className="custom-select__item"
                            style={loadFonts ? {fontSize: '1.2rem', width: 'fit-content'} : null}
                            onClick={handleClick}
                            data-value={option.value}
                            role="option"
                            aria-selected={value === option.value}
                            tabIndex={0}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    handleClick(e);
                                }
                            }}
                        >
                            {option.label}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};
export default ToolbarCustomSelect;
